import AppIcon, { AppIconProps } from "@/common/components/Icons/AppIcon";

interface Props extends AppIconProps {}

export function EntityInlineActionIcon({ ...otherProps }: Props) {
  return <AppIcon fontSize='small' {...otherProps} />;
}
